import { FlowSteps } from '@llura/constants';

import { GlowLogo } from '../../../shared/glow-logo';
import { useStrings } from '../../../hooks/useStrings';
import { useStepTiming } from '../../../lib/analytics';
import { IntroScreen } from '../intro-screen';

interface IntroWelcomeProps {
  onNext: () => void;
  onLogin: () => void;
}

export function IntroWelcome({ onNext, onLogin }: IntroWelcomeProps) {
  useStepTiming(FlowSteps.IntroScreen1);
  const { strings } = useStrings();
  return (
    <IntroScreen
      step={1}
      title={strings.intro.screen1.title}
      italic={strings.intro.screen1.italic}
      body={strings.intro.screen1.body}
      visual={<GlowLogo size={120} />}
      onNext={onNext}
      onLogin={onLogin}
    />
  );
}
